/* dashboard-rediseno (15-oct-2026): LOS AVISOS DE ARRIBA DEL PANEL (BLOQUE D).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Van entre el saludo y la tarjeta para agregar material. Icono a la izquierda, titulo de 15 px
   seminegrita, texto de 13 y los botones a la derecha; en el telefono los botones bajan a lo
   ancho. Radio 16. Tres tonos del documento:
     naranja  fondo #1A120C, borde #3A2414 (invitado, sin creditos, pendientes que continuar);
     rojo     fondo #1C1010, borde #3D1C1C (limite de documentos);
     gris     fondo #141414, borde #2C2C2C (bajada de plan programada).
   La X (si el aviso se cierra hoy) mide 40 y 44 de toque en el telefono. Cuando sale cada aviso
   y lo que hacen sus botones lo decide quien lo monta: esta pieza solo pinta. */
import React from 'react';
import { X } from 'lucide-react';
import { AreaDe44 } from './anatomia';

export const TONOS_DEL_AVISO = {
  naranja: { fondo: '#1A120C', borde: '#3A2414', icono: '#F7A06A' },
  rojo: { fondo: '#1C1010', borde: '#3D1C1C', icono: '#F87171' },
  gris: { fondo: '#141414', borde: '#2C2C2C', icono: '#9A9A9A' },
};

// El boton principal de un aviso (naranja) y el secundario.
// Segunda vuelta (D2): 44 de alto en todo el telefono (abajo de 768), 40 desde ahi.
export const BOTON_AVISO = 'h-11 md:h-10 w-full sm:w-auto px-4 rounded-xl text-[14px] font-semibold inline-flex items-center justify-center whitespace-nowrap disabled:opacity-45';
export const BOTON_AVISO_PRINCIPAL = `${BOTON_AVISO} bg-[#F27A2E] text-[#160A02]`;
export const BOTON_AVISO_SECUNDARIO = `${BOTON_AVISO} bg-[#1B1B1B] border border-[#2C2C2C] text-[#F4F4F3]`;

export default function AvisoDelPanel({
  tono = 'naranja', icono: Icono, titulo, texto, acciones, alCerrar, etiquetaCerrar, testid, cerrarTestid, accionesTestid,
}) {
  const c = TONOS_DEL_AVISO[tono] || TONOS_DEL_AVISO.naranja;
  return (
    <div className="relative rounded-2xl border px-4 py-3.5 sm:px-5"
      style={{ backgroundColor: c.fondo, borderColor: c.borde }} data-testid={testid} data-tono={tono}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className={`flex items-start gap-3 min-w-0 sm:flex-1${alCerrar ? ' pr-10 sm:pr-0' : ''}`}>
          {Icono ? <Icono className="w-5 h-5 shrink-0 mt-px" style={{ color: c.icono }} aria-hidden="true" /> : null}
          <div className="min-w-0">
            {titulo ? <p className="text-[15px] leading-5 font-semibold text-[#F4F4F3] break-words">{titulo}</p> : null}
            {texto ? <div className="text-[13px] leading-[18px] text-[#9A9A9A] mt-0.5 break-words">{texto}</div> : null}
          </div>
        </div>
        {(acciones || alCerrar) ? (
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:shrink-0" data-testid={accionesTestid}>
            {acciones}
            {alCerrar ? (
              <button type="button" onClick={alCerrar} aria-label={etiquetaCerrar}
                className="absolute top-2 right-2 sm:relative sm:top-auto sm:right-auto w-10 h-10 shrink-0 rounded-xl flex items-center justify-center text-[#9A9A9A] hoverable:text-white hoverable:bg-[#1B1B1B]"
                data-testid={cerrarTestid}>
                <AreaDe44 />
                <X className="w-4 h-4" aria-hidden="true" />
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
